<script>
import './assets/base.css'
import SnackbarStore from '@/components/SnackbarStore.vue';
import DistributorLayout from '@/layouts/DistributorLayout.vue';

export default {
  components: { SnackbarStore, DistributorLayout },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'div')
    },
    loggedIn() {
      return this.$store.state.auth.auth.status.loggedIn
    }
  },
  async created() {
    if (this.loggedIn) {
      await this.$store.dispatch('auth/me')
    }
  },
  mounted() {
    this.observeDOMChanges()
  },
  methods: {
    observeDOMChanges() {
      const observer = new MutationObserver(mutationsList => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const target = mutation.target;
            if (target.classList.contains('v-select__content')) {
              const styles = window.getComputedStyle(target)
              const overlayAnchorOrigin = styles.getPropertyValue('--v-overlay-anchor-origin').trim()
              this.handleOverlayAnchorOriginChange(overlayAnchorOrigin)
            }
            if (target.classList.contains('v-autocomplete__content')) {
              const styles = window.getComputedStyle(target)
              const overlayAnchorOrigin = styles.getPropertyValue('--v-overlay-anchor-origin').trim()
              this.handleOverlayAnchorOriginChange(overlayAnchorOrigin)
            }
          }
        }
      });
      const targetElement = document.documentElement;
      observer.observe(targetElement, { attributes: true, subtree: true });
    },
    handleOverlayAnchorOriginChange(value) {
      if (value !== '') {
        if (value === 'top left') {
          document.body.classList.add('overlay-top');
        } else {
          document.body.classList.remove('overlay-top');
        }
      }
    }
  }
}
</script>

<template>
  <component :is="layout">
    <SnackbarStore/>
    <RouterView/>
  </component>
</template>
